import { type GetOAuthTokensResponse, getOAuthTokens } from "../oauth";
import { queryKeys } from "../queryKeys";
import { type QueryOptions, useRequest } from "./useRequest";

export const useGetOAuthTokens = ({
  accountId = "",
  options,
}: {
  accountId?: string;
  options?: QueryOptions<GetOAuthTokensResponse[]>;
}) => {
  const fetchOAuthToken = async () => {
    return await getOAuthTokens(accountId);
  };

  const { data, refetch } = useRequest(
    queryKeys.oauth.tokens(accountId),
    fetchOAuthToken,
    {
      gcTime: 9999999,
      staleTime: Infinity,
      ...options,
    },
  );

  return { tokens: data, refetch };
};
